var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.config),function(item,index){return _c('div',{key:index,attrs:{"field":item.field,"title":item.title,"height":item.height,"sort":item.sort,"filter":item.filter ? JSON.stringify(item.filter) : '',"translateDomain":item.translateDomain,"align":item.align ? item.align : _vm.defaultConfig.align,"width":item.width}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7612d17d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LayuiTableConfig.vue
// module id = null
// module chunks = 